class ProductCarouselTabs extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.setupTagalysObserver()
  }

  setupTagalysObserver () {
    let hasTagalys = false

    this.els.panel?.elements.forEach((panelEl) => {
      if (panelEl.dataset.recommendations === 'tagalys') {
        hasTagalys = true

        const observer = new MutationObserver((mutationsList) => {
          for (const mutation of mutationsList) {
            if (mutation.type === 'childList') {
              const slidesContainer = panelEl.querySelector(
                '.sec-ProductCarousel_Slides',
              )
              if (slidesContainer !== null && slidesContainer !== undefined) {
                this.externalEls.recommendationsCount.element.innerHTML =
                  slidesContainer.childElementCount
              }
            }
          }
        })

        observer.observe(panelEl, { childList: true })

        if (!this.observers) {
          this.observers = []
        }
        this.observers.push(observer)
      }
    })

    if (!hasTagalys) {
      this.externalEls.recommendationsTrigger?.element?.remove()
    }
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    if (this.observers) {
      this.observers.forEach((observer) => observer.disconnect())
      this.observers = []
    }
  }

  setupListeners () {
    super.setupListeners()

    this.handleTabChange = this.handleTabChange.bind(this)
    this.handleRecommendationsEmpty =
      this.handleRecommendationsEmpty.bind(this)

    this.addEventListener(
      'recommendations:empty',
      this.handleRecommendationsEmpty,
    )

    this.els.trigger?.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, 'click', this.handleTabChange)

      if (triggerEl.dataset.tabType === 'smart') {
        this.externalEls.recommendationsTrigger?.element?.addEventListener(
          'click',
          (event) => {
            triggerEl.click()
            triggerEl.scrollIntoView({ behavior: 'smooth', block: 'start' })
          },
        )
      }
    })
  }

  handleTabChange (event) {
    const clickedTrigger = event.target

    this.els.trigger.elements.forEach((triggerEl) => {
      triggerEl.setAttribute(
        'aria-pressed',
        triggerEl.dataset.index === clickedTrigger.dataset.index,
      )
    })

    this.els.link?.elements.forEach((linkEl) => {
      linkEl.setAttribute(
        'aria-hidden',
        linkEl.dataset.index !== clickedTrigger.dataset.index,
      )
    })

    this.els.panel?.elements.forEach((panelEl) => {
      panelEl.setAttribute(
        'aria-hidden',
        panelEl.dataset.index !== clickedTrigger.dataset.index,
      )
    })
  }

  handleRecommendationsEmpty (event) {
    const index = event.detail.index

    const trigger = this.els.trigger?.elements.find(
      (triggerEl) => triggerEl.dataset.index === index,
    )
    if (trigger) {
      trigger.style.display = 'none'
    }

    const link = this.els.link?.elements.find(
      (linkEl) => linkEl.dataset.index === index,
    )
    if (link) {
      link.style.display = 'none'
    }

    const panel = this.els.panel?.elements.find(
      (panelEl) => panelEl.dataset.index === index,
    )
    if (panel) {
      panel.style.display = 'none'
    }

    // If this was the active tab, switch to the first visible tab
    if (trigger && trigger.getAttribute('aria-pressed') === 'true') {
      const firstVisibleTrigger = this.els.trigger?.elements.find(
        (triggerEl) => triggerEl.style.display !== 'none',
      )
      if (firstVisibleTrigger) {
        firstVisibleTrigger.click()
      }
    }
  }
}

if (!customElements.get('product-carousel-tabs')) {
  customElements.define('product-carousel-tabs', ProductCarouselTabs)
}
